import { checkFreelancerData } from '../profile/utils/navigation-guards';

export default [
  {
    name: 'notifications overview',
    path: '/settings/notifications',
    component: () => import('@web/pages/settings/notifications/NotificationsOverview.vue'),
    meta: { title: 'Notificaties' },
    children: [
      {
        name: 'notification',
        path: '',
        components: {
          detailColumn: () => import('@web/components/detail-column/EmptyStateDetailColumn.vue'),
        },
        meta: { 
          title: 'Notificaties',
          showContent: true
        },
        beforeEnter: [checkFreelancerData],
      },
    ]
  },
];
